var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-home" },
    [
      _vm.isMounted && _vm.currentEnrollmentLabel
        ? _c("div", { staticClass: "profile-enrollment" }, [
            _c(
              "div",
              {
                class:
                  "profile-enrollment__desertion-rate profile-enrollment__desertion-rate--" +
                  _vm.desertionStatusColor
              },
              [
                _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm._f("percentageSimple")(
                        _vm.studentProfile.student.desertionProbability
                      )
                    )
                  )
                ]),
                _vm._v(" riesgo de\n      deserción\n    ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "profile-enrollment__content" },
              [
                _c("p", { staticClass: "program" }, [
                  _c("b", [_vm._v("\n          Carrera:\n        ")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.currentEnrollmentLabel || "") +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _vm.enrollmentOptions.length > 1
                  ? _c(
                      "dropdown-button",
                      {
                        attrs: {
                          options: _vm.enrollmentOptions,
                          className: "profile-enrollment__dropdown"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function() {
                                return [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M14.0002 7.99995C14.3682 8.00012 14.6662 8.29886 14.6662 8.66694V9.99995C14.6662 10.884 14.3157 11.7323 13.6906 12.3574C13.0655 12.9825 12.2172 13.333 11.3332 13.333H3.60856L5.13786 14.8623C5.39805 15.1226 5.39815 15.5443 5.13786 15.8046C4.87756 16.0649 4.45584 16.0648 4.19548 15.8046L1.52849 13.1376C1.33187 12.9409 1.28334 12.6519 1.38395 12.4101C1.3889 12.3983 1.39594 12.3874 1.40153 12.3759C1.43313 12.3109 1.47449 12.2493 1.52849 12.1953L4.19548 9.52827C4.4558 9.26831 4.87761 9.2682 5.13786 9.52827C5.39821 9.78862 5.39821 10.2113 5.13786 10.4716L3.60954 11.9999H11.3332C11.8636 11.9999 12.3722 11.7891 12.7472 11.414C13.1223 11.0389 13.3332 10.5304 13.3332 9.99995V8.66694C13.3332 8.29875 13.632 7.99995 14.0002 7.99995ZM10.8615 0.195262C11.1218 -0.0650874 11.5445 -0.0650874 11.8049 0.195262L14.4718 2.86225C14.4877 2.87817 14.4999 2.89696 14.5138 2.91401C14.5273 2.93054 14.542 2.94603 14.5539 2.96382C14.6788 3.15065 14.6996 3.38593 14.6154 3.58882C14.6076 3.60761 14.5965 3.62465 14.5871 3.64253C14.5765 3.66258 14.5666 3.68299 14.5539 3.7021C14.542 3.7199 14.5273 3.73536 14.5138 3.7519C14.4998 3.76915 14.4879 3.78855 14.4718 3.80464L11.8049 6.47163C11.5445 6.7319 11.1218 6.73195 10.8615 6.47163C10.6013 6.2113 10.6013 5.7886 10.8615 5.52827L12.3898 3.99995H4.66618C4.13587 4.00004 3.62711 4.21089 3.25212 4.58589C2.87715 4.96094 2.66618 5.4696 2.66618 5.99995V7.33296C2.66618 7.70104 2.36821 7.99977 2.00017 7.99995C1.63198 7.99995 1.33317 7.70115 1.33317 7.33296V5.99995C1.33317 5.11589 1.68461 4.26765 2.30974 3.64253C2.93475 3.01768 3.78239 2.66703 4.66618 2.66694H12.3908L10.8615 1.13765C10.6016 0.877344 10.6015 0.455496 10.8615 0.195262Z",
                                          fill: "#465669"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1604729711
                        )
                      },
                      [_vm._v("\n        Cambiar carrera\n\n        ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("loading")
        : _c("div", { staticClass: "home-grid" }, [
            _c("div", { staticClass: "infographic" }, [
              _c("ul", { staticClass: "infographic-tabs" }, [
                _c("li", { class: { active: _vm.currentChart == "grades" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.currentChart = "grades"
                        }
                      }
                    },
                    [_vm._v("Promedio semestral")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart" },
                [
                  _vm.currentChart == "grades"
                    ? _c("grades-chart", {
                        attrs: {
                          styles: _vm.chartStyles,
                          "student-id": _vm.studentId,
                          "enrollment-id": _vm.selectedEnrollmentId
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentChart == "assistance"
                    ? _c("assistance-chart", {
                        attrs: { styles: _vm.chartStyles }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-box" }, [
              _c("div", { staticClass: "title" }, [
                _c(
                  "a",
                  {
                    staticClass: "title-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.navigateTo("app.profile.alerts")
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Alertas (" +
                          _vm._s(_vm.studentProfile.activeAlerts) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("next-arrow-icon")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "body is-hidden-mobile" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "is-marginless has-text-weight-medium body__title"
                  },
                  [_vm._v("FACTORES DE RIESGO")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "risk-factors" },
                  _vm._l(_vm.riskFactors, function(r) {
                    return _c(
                      "div",
                      { key: r.code, staticClass: "risk-factors-item" },
                      [
                        _c("span", {
                          staticClass: "risk-factor-indicator",
                          class: { "is-at-risk": r.on }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "risk-factor-name fs-14 is-lowercase"
                          },
                          [_vm._v(_vm._s(r.name))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-box" }, [
              _c(
                "a",
                {
                  staticClass: "title-link",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.navigateTo("app.profile.attentions")
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "Atenciones (" +
                        _vm._s(_vm.studentProfile.attentionStats.total) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("next-arrow-icon")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "body is-hidden-mobile center-content" },
                [
                  _c("div", { staticClass: "metric-list" }, [
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(
                          _vm._s(_vm.studentProfile.attentionStats.pending)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Pendientes")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(_vm._s(_vm.studentProfile.attentionStats.done))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Realizadas")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("percentage")(
                                _vm.studentProfile.attentionStats.participation
                              )
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Participación")
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-box" }, [
              _c(
                "a",
                {
                  staticClass: "title-link",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.navigateTo("app.profile.grades")
                    }
                  }
                },
                [
                  _c("span", [_vm._v("Notas")]),
                  _vm._v(" "),
                  _c("next-arrow-icon")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "body is-hidden-mobile center-content" },
                [
                  _c("div", { staticClass: "metric-list" }, [
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(_vm._s(_vm.studentProfile.student.currentLevel))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Nivel")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("percentage")(
                                _vm.studentProfile.student
                                  .currentCurricularProgress,
                                this.institution
                              )
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Créditos")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-list-item" }, [
                      _c("span", { staticClass: "metric-value" }, [
                        _vm._v(_vm._s(_vm._f("humanizeFloat")(_vm.average)))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "metric-concept" }, [
                        _vm._v("Promedio")
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-box" }, [
              _c(
                "a",
                {
                  staticClass: "title-link",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.navigateTo("app.profile.comments")
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "Comentarios (" +
                        _vm._s(_vm.studentProfile.totalComments) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("next-arrow-icon")
                ],
                1
              ),
              _vm._v(" "),
              _vm.studentProfile.totalComments !== 0
                ? _c("div", { staticClass: "body is-hidden-mobile" }, [
                    _c(
                      "div",
                      { staticClass: "comments-list" },
                      _vm._l(_vm.studentProfile.latestComments, function(c) {
                        return _c(
                          "div",
                          { key: c.id, staticClass: "comment-item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "comment-meta has-text-weight-semibold"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(c.author.name) +
                                    ", " +
                                    _vm._s(
                                      _vm._f("humanizeDate")(c.createdAt)
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "comment-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("truncate")(
                                    c.comment,
                                    _vm.MAX_LENGTH_COMMENTS_RESUME
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            c.comment.length > _vm.MAX_LENGTH_COMMENTS_RESUME
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "see-more",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.navigateTo(
                                          "app.profile.comments"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("ver más")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _c(
                    "p",
                    { staticClass: "body is-hidden-mobile center-content" },
                    [_vm._v("No hay comentarios registrados.")]
                  )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }